import { Component, input } from '@angular/core';
import { EnvIndicatorComponent } from '@shared/components/utils/env-indicator/env-indicator.component';
import { TopBarActionsComponent } from '@shared/components/top-bar/top-bar-actions/top-bar-actions.component';

@Component({
    selector: 'app-dashboard-topbar',
    templateUrl: './dashboard-topbar.component.html',
    imports: [EnvIndicatorComponent, TopBarActionsComponent],
    styleUrls: ['./dashboard-topbar.component.scss']
})
export class DashboardTopbarComponent {
    sidebarOpen = input<boolean>(false);
}
